import { useState } from "react";
import { CvrResultViewModel } from "./CvrSelector.types";
import { ICrvSelector } from "./CvrSelector";
import { useDelayedValue } from "../../common/hooks/useDebounce.hooks";

import { useDotLegalQuery, useDotLegalPostGetQueryWithKey } from "@common/hooks/dotLegalReactQuery";

export function useCrvSelectorHooks(props: ICrvSelector) {
    const [inputValue, setInputValue] = useState("");
    const [showCvr, setShowCvr] = useState(false);
    const [hasFocus, setHasFocus] = useState(false);

    const debouncedInputValue = useDelayedValue(inputValue, 1000);

    const url = "/cvr";
    const { data, isLoading } = useDotLegalPostGetQueryWithKey<Array<CvrResultViewModel>>("/cvr" + debouncedInputValue, url, debouncedInputValue, {
        enabled: debouncedInputValue.length > 0,
    });

    function onSelectResult(id: string | null) {
        if (id) {
            var result = data?.find((x) => x.companyRegistrationNumber.toString() === id);

            props.onSelectLegalEntity(result!);
        }
    }

    return {
        inputValue,
        setInputValue,
        showCvr,
        setShowCvr,
        results: data ?? [],
        isLoading,
        onSelectResult,
        hasFocus,
        setHasFocus,
        noDataFound: debouncedInputValue.length > 0 && !isLoading && data?.length === 0,
    };
}
